import React, { useState, useEffect } from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    Divider,
    Grid,
     Checkbox,
    Snackbar,
    IconButton, // <-- add this import
  } from "@mui/material";

  const ModalConfirm = ({open, close, onConfirmClick,   encProjectId}) =>{

    const confirmClick = () =>{
        onConfirmClick(encProjectId);
    }

    return(
        <Modal
            open={open}
            onClose={close}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontWeight: 600,
                        color: "primary.main",
                        mb: 3,
                    }}
                >
                    Confirm Delete
                </Typography>
                
                <Typography
                    variant="body1"
                    sx={{
                        mb: 3,
                        color: "primary.main"
                    }}
                >
                    By deleting, you will lose access to all saved configured kit products listed under this project. Please click 'Confirm Delete', if you would like to delete.
                </Typography>
                
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                    <Button variant="outlined" onClick={close}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="error" onClick={confirmClick}>
                        Confirm Delete
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
  };

  export default ModalConfirm;